import styled from "@emotion/styled";
import { Pagination, PaginationItem } from "@mui/material";

const Wrapper = styled.div`
  padding: ${p => p.theme.space[4]}px 0;
  margin-bottom: ${p => p.theme.space[7]}px;
  display: flex;
  justify-content: center;
`;

const PaginationStyled = styled(Pagination)`
  .MuiPagination-ul > li:first-of-type {
    margin-right: ${p => p.theme.space[4]}px;
  }

  .MuiPagination-ul > li:last-of-type {
    margin-left: ${p => p.theme.space[4]}px;
  }
`;

const PaginationItemStyled = styled(PaginationItem)`
    
    display: flex;
    align-items: center;
    justify-content: center;
    width: 26px;
    min-width: 26px;
    height: 26px;
    min-height: 26px;
    padding: 0;
    margin: 0;

    border-radius: ${({ theme }) => theme.radii.small};

    font-size: 14px;
    font-weight: 400;
    color: ${({ theme }) => theme.colors.secondary.minor};

    @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
        width: 44px;
        min-width: 44px;
        height: 44px;
        min-height: 44px;
        font-size: 16px;
    }


    &.MuiPaginationItem-root {
        color: ${({ theme }) => theme.colors.secondary.gray};

    &.Mui-selected {
        color: ${({ theme }) => theme.colors.black}
        background-сolor: ${({ theme }) => theme.colors.background}
    };

        &.MuiPaginationItem-previousNext {
            border: 1px solid ${({ theme }) => theme.colors.secondary.stroke};
        }

        &.Mui-disabled {
            opacity: 1;
        }
    }

,

`;

export { Wrapper, PaginationStyled, PaginationItemStyled };
